import React from 'react'
import Link from 'gatsby-link'
import wantsomeImg from '../../images/partners/WWantsome_Logo_Light1_03.png'

const CommEventsEntry = (props) => {
	return (
		<div className="row">
			<div className="col-md-12 col-sm-12 wow fadeInUp">
				<div className="team-wrapper">
					<div className="row">
						{ props.showLeft ?
                        <div className="col-md-2">
                            <br /><br />
							<Link to={props.link}><img src={props.image} className="img-responsive"/></Link>
						</div> : null }
						<div className="col-md-10">
							<h5>{ props.date }</h5>
							<h4><Link to={props.link}>{props.title}</Link></h4>
							<p>
								{props.text}
							</p>
							<p>&nbsp;</p>
						</div>
						{ !props.showLeft ?
                        <div className="col-md-2">
                            <br /><br />
							<Link to={props.link}><img src={props.image} className="img-responsive"/></Link>
						</div> : null }
						<p>&nbsp;</p>
					</div>
				</div>
			</div>
		</div>
	);
};

let events = [
	{
		date: "Saturday, 28 March, 08:30",
		title: "Working effectively with Web API Core 3.1" ,
		link: "/community-events/webapi-core-3-1/" ,
		text: "All you need to know about: API Setup, Performance tips, integrations, testing, templates",
		showLeft: true,
		image: wantsomeImg
	},
	{
		date: "Saturday, 28 March, 13:30",
		title: "Asynchronous and parallel programming concepts using C#" ,
		link: "/community-events/async-tpl-concepts/" ,
		text: "Real hands-on experience workshop about asynchronous and parallel programming concepts using C#",
		showLeft: true,
		image: wantsomeImg
	},
	{
		date: "Saturday, 28 March, 08:30",
		title: "ELK Stack for beginners" ,
		link: "/community-events/elk-stack-beginners/" ,
		text: "This workshop focuses on how to use the ELK stack to build an end-to-end system for monitoring and log aggregation.",
		showLeft: true,
		image: wantsomeImg
	},
	{
		date: "Saturday, 28 March, 13:30",
		title: "Infrastructure as Code for beginners" ,
		link: "/community-events/infrastructure-code-beginners/" ,
		text: "Terraform is powerful and one of the most used tools which allow to manage infrastructure as code in various cloud vendors.",
		showLeft: true,
		image: wantsomeImg
	}
	
]

const communityEventsIndex = () => {
	return (
	<section id="community" className="parallax-section">
		<div className="container">
		<br /><br /><br /><br />
        <div className="row">
            <div className="col-md-offset-2 col-md-8 col-sm-offset-2 col-sm-8">
				<div className="header-title">
					<h1>Free community events</h1>
					<hr />
					<p>On Saturday, 28 March at International Hotel Iasi.<br />
                    The events are free, all you need to do is register until 24 March and then wait for our confirmation<br />
						<b>
						*Hands-On experience, you need your laptop. <br />
						Registration & Confirmation is required
						</b>
					</p>
				</div>
			</div>
        </div>
		{ events.map(event => <CommEventsEntry {...event} />)}
		</div>
	</section>
	)
}
export default communityEventsIndex



// WEBPACK FOOTER //
// ./src/pages/community-events/index.js